/* Kaufweise Header — Off-canvas Mobile-Menu Toggle mit Focus-Trap + inert. */
(function () {
  'use strict';
  var menu = document.querySelector('[data-kw-mmenu]');
  if (!menu) return;

  var panel = menu.querySelector('.mm-panel');
  var openBtns = document.querySelectorAll('[data-kw-menu-open]');
  var lastFocus = null;

  // Hintergrund-Regionen (alles ausser dem Menue) fuer inert/aria-hidden
  function bgRegions() {
    var sel = ['.kw-header', '#MainContent', 'main', '#footer-group', '.kw-announce'];
    var els = [];
    sel.forEach(function (s) {
      document.querySelectorAll(s).forEach(function (el) {
        if (!menu.contains(el) && !el.contains(menu)) els.push(el);
      });
    });
    return els;
  }

  function setBg(on) {
    bgRegions().forEach(function (el) {
      if (on) { el.setAttribute('inert', ''); el.setAttribute('aria-hidden', 'true'); }
      else { el.removeAttribute('inert'); el.removeAttribute('aria-hidden'); }
    });
  }

  function focusables() {
    return Array.prototype.filter.call(
      // summary: seit 2026-07-21 ist die zweite Menue-Ebene ein <details>/<summary>.
      // <summary> ist nativ fokussierbar, matcht aber keinen der uebrigen Selektoren —
      // ohne diesen Eintrag ueberspringt der Focus-Trap den Aufklapp-Schalter.
      panel.querySelectorAll('a[href], button:not([disabled]), input, summary, [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null; }
    );
  }

  function onKey(e) {
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function open() {
    lastFocus = document.activeElement;
    menu.hidden = false;
    requestAnimationFrame(function () { menu.classList.add('open'); });
    document.documentElement.style.overflow = 'hidden';
    setBg(true);
    openBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var closeBtn = menu.querySelector('[data-kw-menu-close]');
    if (closeBtn) closeBtn.focus();
    document.addEventListener('keydown', onKey, true);
  }

  function close() {
    menu.classList.remove('open');
    document.documentElement.style.overflow = '';
    setBg(false);
    openBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    document.removeEventListener('keydown', onKey, true);
    var done = function () { menu.hidden = true; menu.removeEventListener('transitionend', done); };
    menu.addEventListener('transitionend', done);
    setTimeout(function () { if (!menu.classList.contains('open')) menu.hidden = true; }, 350);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  openBtns.forEach(function (b) { b.addEventListener('click', open); });
  menu.querySelectorAll('[data-kw-menu-close]').forEach(function (b) {
    b.addEventListener('click', close);
  });
})();
